import { Grid, Typography, Box } from "@mui/material";
import React from "react";
import { allIcons, allImages } from "../../../assets";

const acceptableData = [
  {
    id: 1,
    name: "Clear interior images of your space",
  },
  {
    id: 2,
    name: "At least 3 images",
  },
  {
    id: 3,
    name: "High resolution images (2727 x 1545)",
  },
];

const unAcceptableData = [
  {
    id: 1,
    name: "Stock images",
  },
  {
    id: 2,
    name: "Logos and brand images",
  },
  {
    id: 3,
    name: "Close ups of your work (E.g Nails, Eyes)",
  },
];

const VenueImageGuidelines = () => {
  return (
    <Grid
      spacing={4}
      container
      sx={{ alignItems: "center", justifyContent: "center", marginTop: "40px" }}
    >
      <Grid item xs={12} sm={6}>
        <Typography
          variant="h3"
          sx={{ fontWeight: "700", fontSize: "35px", margin: "12px 0" }}
        >
          Venue image guidelines
        </Typography>
        <Typography
          variant="h3"
          sx={{
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "22px",
            marginBottom: "15px",
          }}
        >
          Quality images that highlight the beauty, comfort and professionalism
          of your space are the best way to immediately capture the attention of
          potential clients. <span style={{ color: "blue" }}>Learn more</span>
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h3"
              sx={{ fontWeight: "700", fontSize: "20px", margin: "12px 0" }}
            >
              Acceptable
            </Typography>
            <img
              src={allImages.landingSpaImage1}
              style={{ width: "100%", height: "200px", marginBottom: "12px" }}
            />

            {acceptableData.map((itemmmm) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={allIcons.checkCicleInactive}
                    style={{ width: "20px", height: "20px" }}
                  />
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: "400",
                      fontSize: "14px",
                      marginLeft: "10px",
                    }}
                  >
                    {itemmmm.name}
                  </Typography>
                </Box>
              );
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h3"
              sx={{ fontWeight: "700", fontSize: "20px", margin: "12px 0" }}
            >
              Unsuitable
            </Typography>
            <img
              src={allImages.landingSpaImage2}
              style={{ width: "100%", height: "200px", marginBottom: "12px" }}
            />

            {unAcceptableData.map((itemmmm) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src={allIcons.checkCicleInactive}
                    style={{ width: "20px", height: "20px" }}
                  />
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: "400",
                      fontSize: "14px",
                      marginLeft: "10px",
                    }}
                  >
                    {itemmmm.name}
                  </Typography>
                </Box>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default VenueImageGuidelines;
